import { Inject, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { TranslatedToastrService } from './translated-toastr.service';
import { LIB_API_BASE_URL, MessageStatus } from './api-services';

@Injectable()
export class SignalRService {
    private hubConnection: signalR.HubConnection;

    private baseUrl: string;
    constructor(
        private translatedToastrService: TranslatedToastrService,
        @Inject(LIB_API_BASE_URL) baseUrl: string
    ) {
        this.baseUrl = baseUrl;

    }

    public startConnection = (channelId: string) => {
        let signalRUrl = "https://localhost:7227"
        if (this.baseUrl.indexOf("localhost") == -1) {
            signalRUrl = "https://api.vestra-app.com";
        }
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(signalRUrl + `/messagehub?channelId=${channelId}`)
            .build();

        this.hubConnection
            .start()
            .then(() => console.log('SignalR Connection started'))
            .catch(err => console.log('Error establishing SignalR connection: ' + err));

        this.addMessageListener()
    }

    public addMessageListener = () => {
        this.hubConnection.on('ReceiveMessage', (message: string, messageStatus: MessageStatus) => {
            switch (messageStatus) {
                case MessageStatus.Success:
                    this.translatedToastrService.success(message, "common.success");
                    break;
                case MessageStatus.Warning:
                    this.translatedToastrService.warning(message, "common.warning");
                    break;
                case MessageStatus.Error:
                    this.translatedToastrService.error(message, "common.error");
                    break;
            }
        });
    }
}
